import React from 'react';
import type { HeadingBlock as HeadingBlockType } from '../../../types';
import renderTextWithVariables from '../renderTextWithVariables';
import { MarkHeading } from '../../MarkControls';
import P from '@hero/ui-kit/typography/P';
import { useEditorContext } from '../EditorContext';

const HeadingBlock: React.FC<{ block: HeadingBlockType }> = ({ block }) => {
    const { canvas } = useEditorContext();
    if (canvas)
        return (
            <P
                strong
                styles={{
                    fontSize: ['3.2rem', '2.4rem', '2rem', '1.8rem', '1.6rem', '1.4rem'][
                        (block.level ?? 2) - 1
                    ],
                    lineHeight: 1.3,
                    margin: '0.8rem 0'
                }}
            >
                {renderTextWithVariables(block.text)}
            </P>
        );
    const role = `h${block.level || 2}` as React.ComponentProps<typeof MarkHeading>['role'];
    return (
        <MarkHeading role={role} style={{ margin: '0.8rem 0' }}>
            {renderTextWithVariables(block.text)}
        </MarkHeading>
    );
};
export default HeadingBlock;
